export default (that) => [
  {
    text: that.$l('INDEX.btn_view_details') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('btn_view_edit') || '编辑单据',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
    data: {},
    show: ({ resFabricPurchaseStatus }) => resFabricPurchaseStatus === 'N',
  },
  {
    text: that.$l('btn_view_del') || '删除单据',
    icon: 'el-icon-delete',
    menuType: 'delete',
    divided: false,
    allow: 'D',
    data: {},
    show: ({ resFabricPurchaseStatus }) => resFabricPurchaseStatus === 'N',
  },
  {
    text: that.$l('btn_purchase') || '确认采购',
    icon: 'el-icon-s-check',
    menuType: 'confirm',
    divided: true,
    allow: 'C',
    data: {},
    show: ({ resFabricPurchaseStatus }) => resFabricPurchaseStatus === 'N',
  },
  {
    text: that.$l('btn_print') || '单据打印',
    icon: 'el-icon-printer',
    menuType: 'export',
    divided: false,
    allow: 'P',
    data: {},
    show: ({ resFabricPurchaseStatus }) => resFabricPurchaseStatus === 'Y' || resFabricPurchaseStatus === 'R',
  },
  {
    text: that.$l('btn_receive') || '到货确认',
    icon: 'el-icon-box',
    menuType: 'receipt',
    divided: true,
    allow: 'R',
    data: {},
    show: ({ resFabricPurchaseStatus }) => resFabricPurchaseStatus === 'Y',
  }
]
